import React, { useContext, useEffect, useState } from "react";
import { SearchBar } from "../../components";
import OrderHistoryList from "../../components/listComponents/orderHistoryList/OrderHistoryList";
import SortListComponent from "../../components/listComponents/sortListComponent/SortListComponent";
import { AuthContext } from "../../services/context/authContext/AuthContext";
import { db } from "../../services/firebaseConfig";
import { collection, getDocs, where, query, orderBy } from "firebase/firestore";

const OrderHistory = () => {
  const loggedInUser = useContext(AuthContext);
  const userEmail = loggedInUser && loggedInUser.email;
  const [orderListDefault, setOrderListDefault] = useState([]);
  const [orders, setOrders] = useState([]);
  const [sortItem, setSortItem] = useState("recent");
  const [isLoading, setIsLoading] = useState(false);
  const [input, setInput] = useState("");
  const sortList = ["recent", "price", "paid", "unpaid"];
  const admin = loggedInUser?.role === "admin";
  const accountant = loggedInUser?.role === "accountant";

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setIsLoading(true);

        const baseCondition =
          admin || accountant
            ? where("status", "==", "complete")
            : where("createdBy", "==", userEmail);

        const q = query(collection(db, "orders"), baseCondition);
        const orders = await getDocs(q, { source: "server" });

        const orderList = [];

        orders.forEach((doc) => {
          const orderItem = doc.data();
          orderList.push(orderItem);
        });

        setOrderListDefault(orderList);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchOrders();
  }, [userEmail, admin, accountant]);

  useEffect(() => {
    const filter = async () => {
      const baseCondition =
        admin || accountant
          ? where("status", "==", "complete")
          : where("createdBy", "==", userEmail);
      let result = [];
      let q;

      switch (sortItem) {
        case "recent":
          q = query(
            collection(db, "orders"),
            baseCondition,
            orderBy("createdAt", "desc")
          );
          break;
        case "price":
          q = query(
            collection(db, "orders"),
            baseCondition,
            orderBy("totalPrice", "desc")
          );
          break;
        case "paid":
          q = query(
            collection(db, "orders"),
            baseCondition,
            where("isPayed", "==", true),
            orderBy("createdAt", "desc")
          );
          break;
        case "unpaid":
          q = query(
            collection(db, "orders"),
            baseCondition,
            where("isPayed", "==", false),
            orderBy("createdAt", "desc")
          );
          break;
        default:
          q = query(
            collection(db, "orders"),
            baseCondition,
            orderBy("createdAt", "desc")
          );
          break;
      }

      const querySnapshot = await getDocs(q);
      result = querySnapshot.docs.map((doc) => doc.data());

      setOrders(result);
    };
    filter();
  }, [sortItem, orderListDefault, admin, accountant, userEmail]);

  const updateInput = async (input) => {
    const filtered = orderListDefault.filter((order) => {
      if (
        order.company.toLowerCase().includes(input.toLowerCase()) ||
        order.invoiceId.toLowerCase().includes(input.toLowerCase()) ||
        order.createdBy.toLowerCase().includes(input.toLowerCase())
      ) {
        return order;
      }
      return null;
    });
    setInput(input);
    setOrders(filtered);
  };

  return (
    <div className=" max-w-screen-2xl mx-auto">
      <div className="px-5 tablet:px-16 desktop:px-20">
        <h2 className="mb-10">
          {admin || accountant ? "All orders" : "My orders"}
        </h2>
        <div className="flex flex-col mx-4 tablet:mx-0  tablet:flex-row gap-5 mt-16 tablet:items-center ">
          <SearchBar keyword={input} setKeyword={updateInput} />

          <SortListComponent
            items={sortList}
            item={sortItem}
            setItem={setSortItem}
          />
        </div>
        <OrderHistoryList orders={orders} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default OrderHistory;
